import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// components
import FadeCarousel from "Shared/ts/components/fade-carousel"; // adapters

import FadeSlideCarouselAdapter from "Shared/ts/api/carousel/slide/adapters/fade-slide-carousel"; // observers

import { observer } from "Shared/ts/observers/intersection"; // utils

import OfferController from "ts/utils/offer-controller";
import Form from "ts/utils/form";
observer(".slide--fade", {
  inRange: element => {
    var carousel = new FadeCarousel(new FadeSlideCarouselAdapter(element));
    carousel.enablePrevNextControls();
  }
});

class OfferForm extends Form {
  constructor(id) {
    super(id);
    this.initializeOfferRules();
  }

  initializeOfferRules() {
    var _this = this;

    return _asyncToGenerator(function* () {
      var form = yield _this.form;
      var offer = new OfferController(form);
      offer.updateCartOnAction();
      offer.updateCartOnPageLoad();
    })();
  }

  handleNetworkTransaction() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var form = yield _this2.form;
      var statusScreen = yield _this2.statusScreen;
      statusScreen.busy("Please wait...");
      form.submit();
    })();
  }

}

new OfferForm("offer-selection");